import { render } from "./react_button.vue?vue&type=template&id=54e78625"
import script from "./react_button.js?vue&type=script&lang=js"
export * from "./react_button.js?vue&type=script&lang=js"

import "./react_button.vue?vue&type=style&index=0&id=54e78625&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__